// extracted by mini-css-extract-plugin
export default {"body":"notfound_body__9W45U","title":"notfound_title__rR-dG","message":"notfound_message__805OQ","backButton":"notfound_backButton__aAlHH"};